const EnterpriseFooter = () => {
  return (
    <div className="bg-grey-10">
      <div
        className=" flex flex-col md:flex-row
          w-full max-w-[1440px] mx-auto
          py-6 px-4 md:py-4 md:px-10
          justify-center md:justify-between
          items-start md:items-center
          gap-5 md:gap-0
        "
      >
        <div>
          <span className="text-3 leading-5 font-normal md:text-[14px] md:leading-[22px] text-grey-02 font-inter">
            Copyright © 2026 Computechoice.com All rights reserved.
          </span>
        </div>
        <div className="flex items-start gap-8 md:items-center md:gap-6 text-3 leading-5 font-inter font-medium md:text-[14] md:leading-[22px] text-white">
          <a href="/terms">
            <span>Terms of Use</span>
          </a>
          <a href="/privacy-policy">
            <span>Privacy Policy</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseFooter;
